<template>
  <div>
    <button
      v-if="info.title"
      class="text-primary mt-2 cursor-pointer no-underline forget-pass"
      type="button"
      @click.stop="openNewUserConsent"
    >
      {{ info.title }}
    </button>
    <div
      v-if="Boolean(selectedOrganization)"
      class="flex items-center gap-4 mt-2"
    >
      <input
        v-model="newUserConsent"
        id="consent-checkbox"
        type="checkbox"
        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
      />
      <label
        for="consent-checkbox"
        class="cursor-pointer text-sm font-medium text-gray-900"
        v-html="info.label"
      />
    </div>
  </div>
</template>

<script>
import { translateEntity, replaceWithMap } from "@shared/modules/localization/utils/caseEntityTranslation";
import { caseEntityTypesMap } from "@shared/modules/localization/utils/caseEntityTranslation/constants";

export default {
  name: "NewUserConsent",

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    orgId: {
      type: String,
      default: ""
    },
    selectedOrganization: {
      type: Object,
      default: () => ({}),
    },
  },

  beforeDestroy() {
    this.resetParams();
  },

  computed: {
    newUserConsent: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },

    orgType() {
      return this.selectedOrganization?.org_type;
    },

    info() {
      const { new_user_consent_title } = this.selectedOrganization ?? {};

      return {
        title: this.getTranslated(new_user_consent_title),
        label: this.transformedConsent,
      };
    },

    transformedConsent() {
      const { new_user_consent_label } = this.selectedOrganization ?? {};
      if (!new_user_consent_label?.length) return;

      const translatedLabel = this.getTranslated(
        new_user_consent_label, 
        caseEntityTypesMap.AGREEMENT_CHECKBOX
      );
      const urlRegex = /\{\{\s*(https?:\/\/[^\s}]+)\s*\}\}/g;

      return translatedLabel.replace(urlRegex, (match, url) => {
        return `<a href="${url}" target="_blank" class="text-primary underline cursor-pointer">${url}</a>`;
      });
    },
  },

  methods: {
    openNewUserConsent() {
      const routeData = this.$router.resolve({ name: "new-user-consent" });

      localStorage.setItem('org_id', this.orgId);
      localStorage.setItem('org_type', this.orgType);

      window.open(routeData.href, '_blank');
    },

    resetParams() {
      localStorage.removeItem('org_id');
      localStorage.removeItem('org_type');
    },

    getTranslated(el, type = caseEntityTypesMap.FIELD) {
      const translated = translateEntity({ name: replaceWithMap(el) }, type)?.name ?? "";
      return /&#|&%/.test(translated) ? el : translated;
    },
  },
};
</script>
